import { applyGuessBonus, evaluateVotes } from './game-rules';

export interface LocalRoundResult {
  caught: boolean;
  voteCounts: Record<string, number>;
  scores: Record<string, number>;
}

export function scoreLocalRound(
  playerIds: string[],
  imposterId: string,
  votes: Record<string, string>,
  currentScores: Record<string, number>,
): LocalRoundResult {
  const outcome = evaluateVotes(playerIds, imposterId, votes);
  const scores = { ...currentScores };
  for (const playerId of playerIds) {
    scores[playerId] = (scores[playerId] ?? 0) + (outcome.scoreDelta[playerId] ?? 0);
  }
  return { caught: outcome.caught, voteCounts: outcome.voteCounts, scores };
}

export function scoreLocalGuess(
  scores: Record<string, number>,
  imposterId: string,
  correct: boolean,
): Record<string, number> {
  const bonus = applyGuessBonus({}, imposterId, correct);
  return {
    ...scores,
    [imposterId]: (scores[imposterId] ?? 0) + (bonus[imposterId] ?? 0),
  };
}
